<template>
<div>
  <div class="recruit">
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="news">
      <div class="news_title">
        <h1>採用News</h1>
      </div>
      <div class="news_contents">
        <p class="day">2021/9</p>
        <p class="info">観光バス運転士を積極的に募集しています。まずはお気軽にお問い合わせください。</p>
      </div>
    </div>
    <div class="contents">
      <div class="content-title">
        <h1>当社運転士に聞く「当社の魅力」</h1>
        <p>※自社運転士に対するヒアリング</p>
      </div>
      <div class="container-fluid content">
        <div class="row">
          <div class="col-xs-12 col-lg-7 resizeimage">
            <img src="@/assets/driver-1.png"/>
          </div>
          <div class="col-xs-12 col-lg-5 order-md-first resizeimage disc">
            <div class="table-container">
              <div class="table-title text">
                <h2>1. 先輩後輩のしがらみがなく、仕事がしやすい環境</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">当社で働く運転士の圧倒的多数が「仲の良さ」を魅力に挙げています。<br>例えば入庫後、洗車機に入れる順番は台数口であっでも入庫順で、先輩を待つ必要なんて一切ありません。バス業界にはさまざまな風習がありますが、東栄観光バスには古い慣習を時代に合わせて変えることが出来る人々が集まっています。今回は運転士で定年を迎えた方が3名いるため、募集をおこなっています。</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>2. 大多数が中二階バス、高性能洗車機が設置されている</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">車両設備に積極投資しており、大型車・中型車は全社現行型の日野J-BUSを使用し、しかも大型車の約70％が中二階車両です。なお、バスについては担当車制を導入しており、現在は中二階車両の空きもあるため入社後すぐに中二階車両への乗務も可能です。また、運転士の負担を考え、拭き取り作業を大幅に軽減できる、乾燥機能付きダイクマ製の高性能門型自動洗車機をさいたま営業所に、横浜営業所には手動式回転洗車機を設置しています。</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>3. 入社から一人立ちまでの教育研修がしっかりしている</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">実地訓練のみならず、机上教育にもしっかりと時間を費やします。<br>例えば未経験者の場合には、法令で定める以上の時間をかけて、運転法規・車両特性・地理などについて、机上・実技を織り交ぜながら訓練をします。また、当社でよく行く経路として、日光・成田・羽田・都内などの重要ルートについても指導担当が同乗して運転のポイントを指導します。実際の一人乗務を開始するまでに要する訓練期間は約2ヶ月です。加えて、一人立ちしてからも、当分の間は台数口の中に入り、前後の車両から後輩をサポートします。また、定期的に指導者から指導を受けたり、分からないことは先輩に聞くと快く教えてくれます。熱意のある先輩社員がしっかりサポートして実施しますので、大型未経験でも安心です。</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid content">
        <div class="row">
          <div class="col-xs-12 col-lg-7 resizeimage">
            <img src="@/assets/driver-2.png"/>
          </div>
          <div class="col-xs-12 col-lg-5 resizeimage disc">
            <div class="table-container">
              <div class="table-title text">
                <h2>4. 観光バス以外の事業も行っているため災害に強い</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>私たちの会社は社歴55年。大型貨物や工事プラントなど、多角的に経営を行っているため、観光バス事業が災害であっても他の事業でカバーすることが出来ます。そのため、観光業が影響を受けてもリストラや給与カットを避けることができます。<br>例えば今回のコロナでは、大型トラックの運転が出来る人は、月に数回大型トラックに乗務したり、運転が出来ない他の人は、乗用車で大型トレーラーの誘導車運転をしたり、また道路工事用の仕材の積み込み作業の手伝いを行い、バス運転士の手当維持を計りました。その結果、コロナ禍においても運転士は平均月30万円以上の給与を確保しています。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>5. 全社員が熱意を持って仕事に取り組んでいる</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>東栄観光バスはコロナに負けません。<br>例えば、当社の営業社員は日々新しい仕事の確保に努めており、この間もオリンピック輸送・ワクチンバス・企業送迎など、いくつもの仕事を獲得してきました。また、運行管理部門の社員は事故や車両の故障を起こさないよう、現在は毎週すべての拠点の担当者が集まり、運行会議を行っています。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>6. コロナ禍で辞めた運転士が一人もいない</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>観光バス業界はコロナの影響を大きく受けました。しかし当社においては辞めた運転士が一人もおらず、全社員が一丸となって完全復活に向けた準備を始めています。この数ヶ月間も定期的な技能訓練の実施を始め、皆で協力し、今出来る準備を行っています。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>7. 運転士の待遇が良い</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>現在の運転士の給料は入社5年目で平均年収約490万円です。また、1年目の人の給料は、3年前の情報ですが平均年収約430万円でした（最後に入社した方が3年前なので、3年前の情報を記載しています）今回の採用では、初心者の方でも月給27万円を用意します（詳しい内容は面接でお伝えします）。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table_container">
      <div class="table_title">募集要項</div>
      <table class="table">
        <tbody>
          <tr>
            <th>職種・雇用形態</th>
            <td>1．観光バス運転士（正社員）<br>2．送迎バス運転士（契約社員）<br>※経験不問・経験者優遇</td>
          </tr>
          <tr>
            <th>給与</th>
            <td>【正社員】<br>月270,000～<br>【契約社員】<br>月180,000～<br></td>
          </tr>
          <tr>
            <th>勤務時間・休日</th>
            <td>8：00～17：00 ※変動あり<br>週休制</td>
          </tr>
          <tr>
              <th>昇給</th>
              <td>年1回</td>
          </tr>
          <tr>
              <th>賞与</th>
              <td>年2回</td>
            </tr>
            <tr>
              <th>福利厚生・手当</th>
              <td>通勤手当・退職金制度・有給休暇・諸手当<br>独身寮（通勤できない場合のみ・一部自己負担）</td>
            </tr>
            <tr>
              <th>社会保険</th>
              <td>健康保険・厚生年金保険・雇用保険・労災保険</td>
            </tr>
            <tr>
            <th>資格取得制度</th>
            <td>大型二種免許<br>運行管理者資格</td>
            </tr>
            <tr>
              <th>勤務地</th>
              <td>【正社員】<br>さいたま第二営業所（さいたま市岩槻区）<br>横浜営業所（横浜市港北区） <br>【契約社員】<br>さいたま第二営業所（さいたま市岩槻区）</td>
            </tr>
        </tbody>
      </table>
    </div>
    <div class="contact">
      <div class="contact-title">
        <h1>お問い合わせ先</h1>
      </div>
      <div class="contact-content">
        <p>各営業所の採用担当までご連絡ください。</p>
      </div>
      <div class="contact-container">
        <div class="row office-box">
          <div class="col-xs-12 col-lg-6 contact">
            <span>東京営業所</span>
            〒174-0051 東京都板橋区小豆沢2-3-11
            <a href="tel:03-3965-0556">T:03-3965-0556</a>
          </div>
          <div class="col-xs-12 col-lg-6 contact">
            <span>横浜営業所</span>
            〒223-0057 神奈川県横浜市港北区新羽町1187
            <a href="tel:045-540-2710">T:045-540-2710</a>
          </div>
          <div class="col-xs-12 col-lg-6 contact">
            <span>さいたま第二営業所</span>
            〒339-0011 埼玉県さいたま市岩槻区長宮94
            <a href="tel:048-799-1214">T:048-799-1214</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'DRIVER',
      message: '業界最高ランクの安全品質を保つ、安心して働ける会社'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/driver-top.jpg') + "') no-repeat 55% 50%"
  }
}
</script>

<style scoped>
.recruit {
  overflow:hidden;
}
.news{
  padding:2% 4% 4% 4%;
}
.news h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
}
.news_contents {
  padding:10px 15px;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  display:flex;
  margin:0;
}
.day {
  font-size:16px;
  font-weight:bold;
  padding-right:20px;
}
.info {
  font-size:16px;
}
img {
  width: 100%;
}
.works-image {
  text-align:end;
}
.contents {
  padding:2% 4% 4% 4%;
}
.content-title {
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  margin-bottom:20px;
}
.content-title h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
}
h2 {
  font-size:24px;
  font-weight:bold;
  padding-top:20px;
}
.content-title p {
  display:inline;
  padding-left:15px;
}
.table_container {
  padding:2% 4% 4% 4%;
}
.table {
  white-space:pre-line;
}
table td {
  width:70%;
}
.table_title {
  color:#000000;
  font-size:32px;
  font-weight:bold;
  padding-bottom:20px;
}
.contact {
  padding:2% 4% 4% 4%;
  color:#303030;
}
.contact-title h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
}
.contact-content p{
  padding:10px 15px;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.office-box {
  padding: 0px 10% 0px 12%;
}

</style>



// WEBPACK FOOTER //
// src/components/Driver.vue